var ModalManager =
/** @class */
function () {
  function ModalManager() {
    this.modals = [];
  }

  ModalManager.prototype.add = function (modal) {
    var modalIndex = this.modals.indexOf(modal);

    if (modalIndex !== -1) {
      return modalIndex;
    }

    return this.modals.push(modal) - 1;
  };

  ModalManager.prototype.remove = function (modal) {
    var modalIndex = this.modals.indexOf(modal);

    if (modalIndex === -1) {
      return modalIndex;
    }

    this.modals.splice(modalIndex, 1);
    return modalIndex;
  };

  ModalManager.prototype.isTop = function (modal) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
  };

  return ModalManager;
}();

export default ModalManager;